/* ========================================
   A.SHELI — חיפוש: השלמה אוטומטית + הפרדת תוצאות קשורות

   1. שופיפיי לא תומך ב-Predictive Search בעברית (search/suggest.json מחזיר 417).
      לכן ההשלמה משתמשת בחיפוש הרגיל דרך Section Rendering API:
      /search?q=...&section_id=search-suggest
   2. החיפוש הרגיל מוסיף אחרי ההתאמות המדויקות מוצרים שלא מכילים את מילת החיפוש
      ("כובע" ← סקווישי, סביבון). בעמוד התוצאות הם מועברים מתחת לכותרת "אולי יעניין אתכם גם".
   השוואה מנרמלת אותיות סופיות (ן→נ), כדי ש"בלון" יתאים ל"בלונים".
   ======================================== */
(() => {
  if (window.__shSearch) return;
  window.__shSearch = true;

  const FINALS = { 'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ' };
  const norm = (s) =>
    (s || '')
      .toLowerCase()
      .replace(/[ךםןףץ]/g, (c) => FINALS[c])
      .replace(/["'״׳\-–־,.]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  const words = (q) => norm(q).split(' ').filter((w) => w.length >= 2);
  const matches = (title, ws) => {
    const t = norm(title);
    return ws.length > 0 && ws.every((w) => t.includes(w));
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- השלמה אוטומטית ---------- */
  function initSuggest(input) {
    const form = input.closest('form');
    if (!form || input.dataset.shSuggest) return;
    input.dataset.shSuggest = '1';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');

    form.classList.add('sh-suggest-host');
    const box = document.createElement('div');
    box.className = 'sh-suggest';
    box.hidden = true;
    box.id = 'sh-suggest-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-controls', box.id);
    form.appendChild(box);

    let timer;
    let ctrl;
    let shown = '';

    const close = () => {
      box.hidden = true;
      box.innerHTML = '';
      shown = '';
      input.setAttribute('aria-expanded', 'false');
    };
    const links = () => Array.from(box.querySelectorAll('a'));

    async function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url =
        root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=search-suggest';
      try {
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) return close();
        const html = await res.text();
        if (input.value.trim() !== q) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.sh-suggest__inner');
        if (!inner) return close();
        box.innerHTML = '';
        box.appendChild(inner);
        box.hidden = false;
        shown = q;
        input.setAttribute('aria-expanded', 'true');
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        if (ctrl) ctrl.abort();
        close();
        return;
      }
      timer = setTimeout(() => run(q), 250);
    });

    input.addEventListener('focus', () => {
      const q = input.value.trim();
      if (q.length >= 2 && q !== shown) run(q);
    });

    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') {
        e.stopPropagation();
        close();
      } else if (e.key === 'ArrowDown') {
        const l = links();
        if (l[0]) {
          e.preventDefault();
          l[0].focus();
        }
      }
    });

    box.addEventListener('keydown', (e) => {
      const l = links();
      const i = l.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < l.length - 1) {
        e.preventDefault();
        l[i + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (i > 0 ? l[i - 1] : input).focus();
      } else if (e.key === 'Escape') {
        e.stopPropagation();
        close();
        input.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });
    form.addEventListener('reset', close);
  }

  /* ---------- עמוד התוצאות: מדויקות קודם, קשורות מתחת לכותרת ---------- */
  function splitResults() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    const params = new URLSearchParams(location.search);
    const sort = params.get('sort_by');
    if (sort && sort !== 'relevance') return;
    const ws = words(params.get('q'));
    if (!ws.length) return;

    const list = document.querySelector('#product-grid ul.product-grid');
    if (!list || list.dataset.shSplit) return;
    list.dataset.shSplit = '1';

    const items = Array.from(list.children).filter((li) => li.classList.contains('grid__item'));
    const other = items.filter((li) => {
      const h = li.querySelector('.card__heading');
      return h && !matches(h.textContent, ws);
    });
    const exactCount = items.length - other.length;
    /* בלי התאמות מדויקות בעמוד (מילים נרדפות, עמוד 2 והלאה) — לא מפרידים. */
    if (!other.length || !exactCount) return;

    const head = document.createElement('li');
    head.className = 'grid__item sh-related-heading';
    head.innerHTML = '<h2 class="h4">אולי יעניין אתכם גם</h2>';
    list.appendChild(head);
    other.forEach((li) => list.appendChild(li));
  }

  const boot = () => {
    document
      .querySelectorAll('form[action$="/search"] input[type="search"][name="q"]')
      .forEach(initSuggest);
    splitResults();
    /* סינון/מיון מרעננים את הרשת ב-AJAX — מפרידים מחדש. */
    const container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(splitResults).observe(container, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
